import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-cf-dropdown',
    standalone: true,
    templateUrl: './cf-dropdown.component.html',
    styleUrls: ['./cf-dropdown.component.scss'],
    imports: [CommonModule]
})
export class CfDropdownComponent implements OnChanges {
    @Input() options!: CFDropdownOptions;
    @Input() align: CFDropdownMenuPosition = CFDropdownMenuPosition.Left;
    @Input() enabled = true;

    @Output() dropdownSelected: EventEmitter<CFDropdownItem> = new EventEmitter();
    @Output() parentSelected = new EventEmitter();

    DropdownType = CFDropdownItemType;
    displayChild = false;
    buttonClass = {};
    dropdownClass = {};

    ngOnChanges(changes: SimpleChanges): void {
        this.buttonClass = this.getButtonClass();
        this.dropdownClass = this.getDropdownClass();
    }

    onClickParent(): void {
        if (!this.options.disabled) {
            this.parentSelected.emit();
            if (this.options.items) {
                console.log(`Show child`);
                this.displayChild = true;
            }
        }
    }

    onClick(item: CFDropdownItem): void {
        if (!item.disabled) {
            this.dropdownSelected.emit(item);
            this.displayChild = false;
        }
    }

    closeMenu(): void {
        this.displayChild = false;
    }

    getButtonClass() {
        const type = (this.options.buttonClass?.toString() ?? CFDropdownButtonClass.MenuDefault.toString()).toLowerCase();
        return {
            dropdown: true,
            'default-menu': type == "menu",
            'success': type == "success",
            'primary': type == "primary",
            'secondary': type == "secondary",
            'tertiary': type == "tertiary",
            'default': type == "default",
            'danger': type == "danger",
            'cancel': type == "cancel",
            'secondary-light': type == 'secondarylight',
            'solid-success': type == 'solidsuccess',
            'solid-danger': type == 'soliddanger',
            'disabled': this.options.disabled ?? false,
        }
    }

    getDropdownClass() {
        const type = (this.options.itemClass?.toString() ?? CFDropdownButtonClass.MenuDefault.toString()).toLowerCase();
        const align = this.align.toString().toLowerCase();
        return {
            'dropdown-content': true,
            'default-menu': type == "menu",
            'success': type == "success",
            'primary': type == "primary",
            'secondary': type == "secondary",
            'tertiary': type == "tertiary",
            'default': type == "default",
            'danger': type == "danger",
            'cancel': type == "cancel",
            'secondary-light': type == 'secondarylight',
            'solid-success': type == 'solidsuccess',
            'solid-danger': type == 'soliddanger',
            'menu-left': align == 'left',
            'menu-right': align == 'right',
        }
    }
}

export interface CFDropdownOptions {
    text?: string;
    imageClass?: string;
    showIndicator: boolean;
    leftMargin?: string;
    items?: CFDropdownItem[];
    buttonClass?: CFDropdownButtonClass;
    itemClass?: CFDropdownButtonClass;
    disabled?: boolean;
}

export interface CFDropdownItem {
    id?: number;
    type: CFDropdownItemType;
    imageClass?: string;
    text?: string;
    link?: string; // item name or routerLink
    disabled?: boolean;
}

export enum CFDropdownItemType {
    TextOnly,
    ImageAndText,
    Separator
}

export enum CFDropdownMenuPosition {
    Left = 'left',
    Right = 'right'
}

export enum CFDropdownButtonClass {
    MenuDefault = 'Menu',
    Primary = "Primary",
    Secondary = "Secondary",
    Tertiary = "Tertiary",
    Default = "Default",
    Success = "Success",
    Cancel = "Cancel",
    Danger = "Danger",
    SecondaryLight = "SecondaryLight",
    SolidSuccess = "SolidSuccess",
    SolidDanger = "SolidDanger",
}